import nth from 'lodash-es/nth';
import moment from 'moment-es6';

export function seconds_to_time(s = 0) {
  const minutes = Math.floor(s / 60);
  const seconds = Math.floor(s % 60);
  return `${minutes}`.padStart(2, '0') + ':' + `${seconds}`.padStart(2, '0');
}

export function time_to_seconds(time_string = '00:00:00') {
  const time_array = time_string.split(':');
  const hours = nth(time_array, -3) || '00';
  const minutes = nth(time_array, -2) || '00';
  const seconds = nth(time_array, -1) || '00';
  return parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
}

export const get_time_to_seconds = (time = '00:00') => {
  const formatted_time = moment(time, 'HH:mm').diff(moment().startOf('day'), 'seconds');
  return formatted_time;
};

export const get_seconds_to_time = (seconds = 0) => {
  const formatted_time = moment().startOf('day').seconds(seconds).format('HH:mm');
  return formatted_time;
};
